import React, { useEffect, useState } from "react";

import { ReactComponent as NumberOfParcels } from "../../../../assets/novosicones/Renegociacao/format_list_numbered_black_24dp.svg";

import DropDown from "../../../Reutilizaveis/DropDown";

import { Item, ItemContent } from "./styles.js";

const NumeroParcelas = ({ item, estilo, tema, regras, setRegras }) => {
  const [numeroParcelas, setNumeroParcelas] = useState("");

  let parcelas = [];
  //  [
  //   {
  //     id: 4,
  //     nome: "4x (quatro vezes)",
  //   },
  //   {
  //     id: 5,
  //     nome: "5x (cinco vezes)",
  //   },
  //   {
  //     id: 6,
  //     nome: "6x (seis vezes)",
  //   },
  // ];

  useEffect(() => {
    setRegras({ ...regras, numeroParcelas: numeroParcelas });
  }, [numeroParcelas]);

  // useEffect(() => {
  if (regras?.qtdeParcelas?.length > 0) {
    regras?.qtdeParcelas.forEach((item, index) => {
      parcelas.push({ id: index, nome: item });
    });
  }
  // }, [regras?.qtdeParcelas]);

  return (
    <Item ref={item}>
      <span>
        <b>Número de parcelas:</b>
      </span>
      <ItemContent>
        <NumberOfParcels
          className="iconeRenegociacao"
          style={
            numeroParcelas ? { fill: tema.primaryColor } : { fill: "#4d4d4d" }
          }
        />
        <DropDown
          itens={parcelas}
          idDropDown={"ListaNumeroParcelas"}
          setValue={setNumeroParcelas}
          // label="Selecione o número de parcelas"
          nomeDropDown="Selecione o número de parcelas"
          // obrigatorio="true"
          style={{ margin: 0, border: 0 }}
          renegociacao
          renegociacaoWidth={estilo}
          // widthMeuImovel="calc(100% - 19px)"
          // marginLeftMeuImovel="0px"
          // error={mensagemErroPodeOuNaoSolicitar}
        />
      </ItemContent>
    </Item>
  );
};

export default NumeroParcelas;
